<template>
  <div v-if="showModal">
    <!-- Modal -->
    <div class="modal fade show d-block" tabindex="-1" aria-labelledby="sessionExpiredModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-0">
            <h5 class="modal-title" id="sessionExpiredModalLabel">
              <i class="mdi mdi-clock-outline text-warning mr-2"></i>
              Session Expired
            </h5>
          </div>
          <div class="modal-body text-center py-4">
            <div class="mb-3">
              <img src="@/assets/images/company_logo_2.png" alt="Wiremit Logo" height="50" class="mb-3" />
            </div>
            <h6 class="mb-3">Your session has expired</h6>
            <p class="text-muted mb-4">
              For your security, you have been logged out due to inactivity. 
              Please sign in again to continue.
            </p>
            <div class="d-flex justify-content-center">
              <button @click="redirectToLogin" class="btn btn-primary w-md">
                <i class="mdi mdi-login mr-1"></i>
                Sign In Again
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Modal backdrop -->
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
import { safeNavigate } from '@/router/navigation-guard';
import router from '@/router/index';

export default {
  name: 'SessionExpiredModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showModal: this.visible
    };
  },
  watch: {
    visible(newVal) {
      this.showModal = newVal;
    }
  },
  methods: {
    redirectToLogin() {
      this.showModal = false;
      this.$emit('close');
      // Use safe navigation to login page
      safeNavigate(router, '/login');
    }
  },
  mounted() {
    // Prevent body scrolling when modal is open
    if (this.showModal) {
      document.body.classList.add('modal-open');
    }
  },
  beforeDestroy() {
    // Clean up body class
    document.body.classList.remove('modal-open');
  }
};
</script>

<style scoped>
.modal {
  z-index: 1055;
}

.modal-backdrop {
  z-index: 1050;
}

.modal-content {
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.modal-header {
  padding: 1.5rem 1.5rem 0;
}

.modal-body {
  padding: 0 1.5rem 1.5rem;
}

/* Ensure modal appears on top */
body.modal-open {
  overflow: hidden;
}
</style>
